-<template>
    <v-dialog v-model="dialogDeleteEdit" persistent max-width="290">
      <template v-slot:activator="{ on, attrs }">
        <v-btn style="position:fixed;bottom:5vh;left:2vh" v-if="isDeleteBtn"  fab  left :disabled="readOnly==='true'?true:readOnly=='false'?false:readOnly" color="white"  v-bind="attrs" v-on="on">
          <i style="font-size:2rem" class="mdi mdi-delete-outline black--text"></i>
        </v-btn>
        <v-btn v-else style="position:fixed;bottom:5vh;right:2vh" fab right :disabled="readOnly==='true'?true:readOnly=='false'?false:readOnly" color="primary" v-bind="attrs" v-on="on">
          <i style="font-size:2rem" class="mdi mdi-square-edit-outline"></i>
        </v-btn>
      </template>
      <v-card v-if="loading!=true">
        <v-container>
          <v-row>
            <v-col>
          <span class="beforeLeaveCreate" v-if="isDeleteBtn">{{$t("eraseStoryTitle")}}</span>
          <span class="beforeLeaveCreate" v-else>{{$t("editStoryTitle")}}</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
          <span  v-if="isDeleteBtn==true">{{$t("eraseStoryDescription")}}</span>
          <span v-else></span>
            </v-col>
          </v-row>
          <v-row>
              <v-col class="text-center" cols="6">
                <v-btn color="green darken-1" :disabled="readOnly==='true'?true:readOnly=='false'?false:readOnly" text @click="deleteEditStory()">
                  {{$t("yes")}}
                </v-btn>
              </v-col>
              <v-col class="text-center" cols="6">
                <v-btn color="green darken-1"  :disabled="readOnly==='true'?true:readOnly=='false'?false:readOnly" text @click="dialogDeleteEdit = false">
                  {{$t("no")}}
                </v-btn>
              </v-col>
            </v-row>
          </v-container>

      </v-card>
      <v-card v-else>
        <v-container fill-height fluid>
          <v-row align="center" justify="center">
            <v-col align="center" justify="center" cols=12>
          <v-progress-circular
            indeterminate
            color="primary"
          ></v-progress-circular>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>

</template>

<script>
//based on the parameters I display the edit or delete button
export default {
  name: 'deleteEditStory',
  data() {
    return {
      readOnly:process.env.VUE_APP_READONLY,
      dialogDeleteEdit: false,
      apiURL: process.env.VUE_APP_ROOT_API,
      apiStrapi: process.env.VUE_APP_ROOT_STRAPI
    }
  },
  mounted() {},
  methods: {
    // retrive the story owned by the user
    async deleteEditStory() {
      this.$store.dispatch('setLoading', true)

      //delete story - DELETE
      if (this.isDeleteBtn) {
        try {
          let deleteEditStory = await this.$axios.delete(`${process.env.VUE_APP_ROOT_API}/deleteStory?id=` + this.storyID, {
            headers: {
              "x-access-token": `Bearer ${this.$store.getters.getAccessToken}`,
              'Content-Type': 'multipart/form-data',
            }
          })
          console.info(deleteEditStory)
          this.$store.dispatch('setLoading', false)
          this.$store.dispatch("setSnackbar", {
            color: 'green',
            text: this.$t('theStoryDeleteOk', [this.storyTitle]),
            active: true
          })
          this.dialogDeleteEdit = false
          // EVENT success
          this.$store.dispatch('setLoading', false)
          this.$router.push({'name': 'home'})
        } catch (error) {
          console.log(error);
          this.$store.dispatch('setLoading', false)
          this.$store.dispatch("setSnackbar", {
            color: 'red',
            text: this.$t('theStoryDeleteFail'),
            active: true
          })

        }
      } else {
        //pass all parameters to edit a story
        //reset temp info for edit story
        this.$store.dispatch("clearNewStory")
        this.$indexdb.mediaFiles.clear()
        //EDIT
        //recover all the information of the single story and save them in vuex
        //reaading all story media file and save in vuex


        //COVER IMAGE
        let tempImageFileRawUrl
        let tempImageFileRaw

        if (this.singleStory.cover_image != null) {
          tempImageFileRawUrl = await this.getMediaFileUrlWithCode(this.singleStory.cover_image.media.url)
          tempImageFileRaw = await this.getMediaFile(tempImageFileRawUrl)
          //save image on indexed db and the name on vuex

          this.$indexdb.mediaFiles.add({
            name: this.singleStory.cover_image.title,
            type: tempImageFileRaw.type,
            mediatype: 'image',
            blob: tempImageFileRaw,
            size: tempImageFileRaw.size
          })

          //        this.tempMediaOnIndexDB = {...this.tempMediaOnIndexDB, imageTitle: this.singleStory.cover_image.title, imageSize: tempImageFileRaw.size}
          //        await this.$store.dispatch("setTempMediaOnIndexDB", {...this.tempMediaOnIndexDB, imageTitle: this.singleStory.cover_image.title, imageSize: tempImageFileRaw.size})
          await this.$store.dispatch("addimageObjOntempMediaOnIndexDB", this.singleStory.cover_image)
          await this.$store.dispatch("addImageTitleOntempMediaOnIndexDB", this.singleStory.cover_image.title)
          await this.$store.dispatch("addImageSizeOntempMediaOnIndexDB", tempImageFileRaw.size)
          await this.$store.dispatch("addImageIDOntempMediaOnIndexDB", this.singleStory.cover_image.id)
          //this.tempMediaOnIndexDB = {...this.tempMediaOnIndexDB, imageSize: tempImageFileRaw.size}
          //console.log("after-- this.tempMediaOnIndexDB",this.tempMediaOnIndexDB)
          //console.log("{...this.tempMediaOnIndexDB, imageTitle: this.singleStory.cover_image.title}",{...this.tempMediaOnIndexDB, imageTitle: this.singleStory.cover_image.title})
        }

        //VIDEO
        let tempVideoFileRawUrl
        let tempVideoFileRaw

        if (this.singleStory.video != null) {
          tempVideoFileRawUrl = await this.getMediaFileUrlWithCode(this.singleStory.video.media.url)
          tempVideoFileRaw = await this.getMediaFile(tempVideoFileRawUrl)

          //TODO check if file isn't already saved
          this.$indexdb.mediaFiles.add({
            name: this.singleStory.video.title,
            type: tempVideoFileRaw.type,
            mediatype: 'video',
            blob: tempVideoFileRaw,
            size: tempVideoFileRaw.size
          })
          //save video on indexed db and the name on vuex

          await this.$store.dispatch("addVideoTitleOntempMediaOnIndexDB", this.singleStory.video.title)
          await this.$store.dispatch("addVideoSizeOntempMediaOnIndexDB", tempVideoFileRaw.size)
          await this.$store.dispatch("addVideoIDOntempMediaOnIndexDB", this.singleStory.video.id)

        }

        //Images
        let tempImagesFileRawUrl
        let tempImagesFileRaw
        let tempArrayImagesFileRaw = []

        for (const element of this.singleStory.images) {
          tempImagesFileRawUrl = await this.getMediaFileUrlWithCode(element.media.url)
          tempImagesFileRaw = await this.getMediaFile(tempImagesFileRawUrl)
          //TODO check if file isn't already saved
          this.$indexdb.mediaFiles.add({
            name: element.title,
            type: tempImagesFileRaw.type,
            mediatype: 'image',
            blob: tempImagesFileRaw,
            size: tempImagesFileRaw.size
          })
          this.$store.dispatch("addImagesOntempMediaOnIndexDB", {
            title: element.title,
            size: tempImagesFileRaw.size,
            id: element.id,
            mime: element.media.mime
          })
          //save Images on indexed db and the name on vuex
          tempArrayImagesFileRaw.push(tempImagesFileRaw)
        }




        //Attachments
        let tempAttachmentFileRawUrl
        let tempAttachmentFileRaw
        let tempArrayAttachmentFileRaw = []

        for (const element of this.singleStory.attachments) {
          tempAttachmentFileRawUrl = await this.getMediaFileUrlWithCode(element.media.url)
          tempAttachmentFileRaw = await this.getMediaFile(tempAttachmentFileRawUrl)
          //TODO check if file isn't already saved
          this.$indexdb.mediaFiles.add({
            name: element.title,
            type: tempAttachmentFileRaw.type,
            mediatype: 'other',
            blob: tempAttachmentFileRaw,
            size: tempAttachmentFileRaw.size
          })
          this.$store.dispatch("addAttachmentOntempMediaOnIndexDB", {
            title: element.title,
            size: tempAttachmentFileRaw.size,
            id: element.id,
            mime: element.media.mime
          })
          //save Attachment on indexed db and the name on vuex
          tempArrayAttachmentFileRaw.push(tempAttachmentFileRaw)
        }



        //AUDIOS
        let tempAudioFileRawUrl
        let tempAudioFileRaw
        let tempArrayAudioFileRaw = []

        for (const element of this.singleStory.audios) {
          tempAudioFileRawUrl = await this.getMediaFileUrlWithCode(element.media.url)
          tempAudioFileRaw = await this.getMediaFile(tempAudioFileRawUrl)
          //TODO check if file isn't already saved
          this.$indexdb.mediaFiles.add({
            name: element.title,
            type: tempAudioFileRaw.type,
            mediatype: 'audio',
            blob: tempAudioFileRaw,
            size: tempAudioFileRaw.size
          })
          this.$store.dispatch("addAudioOntempMediaOnIndexDB", {
            title: element.title,
            size: tempAudioFileRaw.size,
            id: element.id,
            mime: element.media.mime
          })
          //save audio on indexed db and the name on vuex
          tempArrayAudioFileRaw.push(tempAudioFileRaw)
        }

        this.$store.dispatch("setNewStories",
          ({
            isStoryID: this.singleStory.id,
            storyTitle: this.singleStory.title,
            content: this.singleStory.content,
            KGselectedOnlyImage: this.singleStory.KGArrayImg,
            marker: {
              lat: this.singleStory.latitude,
              lng: this.singleStory.longitude
            },
            tags: this.singleStory.tags,
            /*          imageFileRaw: tempImageFileRaw,
                        imageFile: null,
                        imageType: "image/jpeg",
                        audioFiles: [],
                        audioFilesRaw: tempArrayAudioFileRaw,
                        audioTypes: [],
                        audioFileTitles: [],
                        videoFileRaw: tempVideoFileRaw,
                        videoFile: null,
                        videoType: "video/mp4",*/
            checkboxPublic: this.singleStory.is_published
          })
        )

        this.$store.dispatch('setisStoryEditediNeedToReloadStories', false)

        this.$store.dispatch('setLoading', false)
        this.dialogDeleteEdit = false
        this.$router.push({
          name: 'createNewStoryContent'
        })
      }
    },
    async getMediaFileUrlWithCode(mediaUrl) {

      let result = await this.$axios.get(this.apiURL + '/generateMediaUuid', {
        headers: {
          "x-access-token": `Bearer ${this.$store.getters.getAccessToken}`,
          'Content-Type': 'multipart/form-data',
        }
      })
      return this.effectiveUrl = mediaUrl + '?code=' + result.data.code
    },

    //after generate the uuid ->axios
    async getMediaFile(mediaUrl) {
      let result = await this.$axios({
        method: 'get',
        url: this.apiStrapi + mediaUrl,
        responseType: 'blob'
      })
      return result.data
    }
  },
  props: {
    storyID: {
      type: Number,
      required: false
    },
    isDeleteBtn: {
      type: Boolean,
      required: true
    },
    singleStory: {
      type: Object,
      required: false
    }
  },
  components: {},
  computed: {
    loading: {
      get: function () {
        return this.$store.getters.getLoading;
      }
    },
    tempMediaOnIndexDB: {
      get: function () {
        return this.$store.state.tempMediaOnIndexDB
      },
      set: function (newValue) {

        this.$store.dispatch("setTempMediaOnIndexDB", newValue)
      }
    },
    accessToken: {
      get: function () {
        return this.$store.getters.getAccessToken;
      }
    }
  },
}
</script>
<style>
.beforeLeaveCreate{
  font-weight: bold;
  font-size: 1.2rem;
}
</style>